import React from 'react';

import SelectInput, { SelectOption } from '../SelectInput';
import useSorting from './useSorting';

interface Props {
  sortOptions: SelectOption[]
}

const Sorting = ({ sortOptions }: Props): React.ReactElement | null => {
  const { sortBy, setSortBy } = useSorting();

  if (!sortOptions.length) {
    return null;
  }

  return (
    <div className="sorting">
      {sortOptions && (
        <SelectInput
          options={sortOptions}
          label="Sort by"
          onChange={(e) => setSortBy(e)}
          value={sortBy}
        />
      )}
    </div>
  );
};

export default Sorting;
